export function isNegativeBacktest(backtest) {
  return backtest?.blocked !== false;
}

export function formatBacktestPercent(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return '—';
  const sign = number < 0 ? '−' : number > 0 ? '+' : '';
  return `${sign}${Math.abs(number).toFixed(2).replace('.', ',')}%`;
}

export function formatProfitFactor(backtest) {
  if (backtest?.profitFactorInfinite === true) return '∞';
  const number = Number(backtest?.profitFactor);
  return Number.isFinite(number) ? number.toFixed(1).replace('.', ',') : '—';
}

export function formatWeightedProfitFactor(backtest) {
  if (backtest?.weightedProfitFactorInfinite === true) return '∞';
  const number = Number(backtest?.weightedProfitFactor);
  return Number.isFinite(number) ? number.toFixed(1).replace('.', ',') : '—';
}

export function formatStrategyHealthBanner(health) {
  const status = health?.blocked === false ? 'Liberada' : 'Bloqueada';
  const hasNetProfitFactor = health && (
    Object.prototype.hasOwnProperty.call(health, 'weightedNetProfitFactor')
    || Object.prototype.hasOwnProperty.call(health, 'weightedNetProfitFactorInfinite')
  );
  const netProfitFactorInfinite = hasNetProfitFactor
    ? health?.weightedNetProfitFactorInfinite === true
    : health?.weightedProfitFactorInfinite === true;
  const netProfitFactor = hasNetProfitFactor ? health?.weightedNetProfitFactor : health?.weightedProfitFactor;
  const profitFactor = netProfitFactorInfinite
    ? '∞'
    : Number.isFinite(Number(netProfitFactor))
      ? Number(netProfitFactor).toFixed(2).replace('.', ',')
      : '—';
  const expectancy = formatBacktestPercent(health?.weightedNetExpectancyPct);
  const trades = Number.isFinite(Number(health?.trades ?? health?.tradesTotal))
    ? Number(health.trades ?? health.tradesTotal)
    : '—';
  const values = `${status}: PF pond ${profitFactor} · líquida pond ${expectancy} · ${trades} trades`;
  const rule = health?.rule?.text;
  const failures = Array.isArray(health?.failures) && health.failures.length
    ? ` · Motivos: ${health.failures.join(', ')}`
    : '';
  return rule ? `${values} · Regra: ${rule}${failures}` : `${values}${failures}`;
}